import MarkdownTextarea from 'src/components/common/markdown-textarea';
import { FormSection } from './FormSection';

const ContentSection = ({ inputs, handleInputs, errorInputs, loading }) => (
  <FormSection
    id="contenido"
    number={6}
    title="Contenido"
    description="Textos que verá el asistente antes de inscribirse y al confirmar."
  >
    <MarkdownTextarea
      loading={loading}
      inputs={inputs}
      name="confirmDataInfo"
      label="Información preliminar"
      handleInputs={handleInputs}
      errorInputs={errorInputs}
      showHelpers={false}
    />
    <MarkdownTextarea
      loading={loading}
      inputs={inputs}
      name="summaryInfo"
      label="Información en confirmación"
      handleInputs={handleInputs}
      errorInputs={errorInputs}
    />
  </FormSection>
);

export default ContentSection;
